<template>
  <div>
    <!-- 承包权数据表格 -->
    <el-table :data="contractData" style="width: 100%">
      <el-table-column
        prop="contractNo"
        label="承包合同编号"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="landType"
        label="土地类型"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="contractArea"
        label="面积(亩)"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="totalQuantity"
        label="地块总数量"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column prop="landOwner" label="发包方" width="180" align="center"></el-table-column>
      <el-table-column
        prop="contractTerm"
        label="承包期限"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="holderName"
        label="户主姓名"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="relationship"
        label="申请人与户主关系"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ContractDataTab',
  props: {
    contractInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 承包权数据表格数据
      _contractData: [
      {
        contractNo: 'HT20230615001',
        landType: '耕地',
        contractArea: 120.5,
        totalQuantity: 3,
        landOwner: 'XX村集体经济组织',
        contractTerm: '2020-01-01 至 2029-12-31',
        holderName: '张三',
        relationship: '本人'
      },
      {
        contractNo: 'HT20230615002',
        landType: '林地',
        contractArea: 85.3,
        totalQuantity: 2,
        landOwner: 'YY村集体经济组织',
        contractTerm: '2018-03-15 至 2048-03-14',
        holderName: '李四',
        relationship: '父子'
      }
      ]
    }
  },
  computed: {
    contractData() {
      return this.mapToContractData(this.contractInfoList)
    }
  },
  methods: {
    mapToContractData(data) {
      return data.map(item => ({
        contractNo: item.cbhtbm || '',           // 承包合同编号
        landType: item.lzhtdyt || '',            // 土地类型
        contractArea: item.htzmj || '',           // 面积(亩)
        totalQuantity: item.cbdkzs || '',          // 地块总数量
        landOwner: item.fbfmc || '',              // 发包方
        contractTerm: `${item.cbqxq || ''} 至 ${item.cbqxz || ''}`,  // 承包期限
        holderName: item.cbfmc || '',            // 户主姓名
        relationship: item.yhzgx || ''           // 申请人与户主关系
      }))
    }
  }
}
</script>

<style lang="less" scoped>
.contract-card {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
}

/* 业务数据标题样式 */
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

// 承包权编号链接样式
.contract-number-link {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}
</style>
